import React from 'react'
import { Container } from 'reactstrap'
import BreadCrumb from '../../../Components/Common/BreadCrumb'

export default function ManageCommands() {
  return (
    <>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title={'Manage Commands'} pageTitle={"Dashboard"} />
                </Container>
            </div>
        </>
  )
}
